var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import { Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import axios from 'axios';
export default function AddCultureDialog({ token, open, setState, update }) {
    const [name, setName] = React.useState('');
    const [code, setCode] = React.useState('');
    const create = () => __awaiter(this, void 0, void 0, function* () {
        yield axios.post('/culture/create', {
            cultures_name: name,
            cultures_code: code === '' ? null : Number(code)
        }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        setName('');
        setCode('');
        setState(false);
        update === null || update === void 0 ? void 0 : update();
    });
    return (React.createElement(Dialog, { maxWidth: 'xs', open: open, onClose: () => setState(false) },
        React.createElement(DialogTitle, null, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043A\u0443\u043B\u044C\u0442\u0443\u0440\u0443"),
        React.createElement(DialogContent, null,
            React.createElement(Stack, { spacing: 2, sx: { mt: 1 } },
                React.createElement(TextField, { label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", fullWidth: true, value: name, onChange: (e) => setName(e.target.value) }),
                React.createElement(TextField, { label: "\u041A\u043E\u0434", type: "number", fullWidth: true, value: code, onChange: (e) => setCode(e.target.value) }))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: () => setState(false) }, "\u041E\u0442\u043C\u0435\u043D\u0430"),
            React.createElement(Button, { variant: "contained", onClick: create, disabled: !name }, "\u0421\u043E\u0437\u0434\u0430\u0442\u044C"))));
}
